// extracted by mini-css-extract-plugin
module.exports = {"formDiv":"Form_formDiv__3_G-8","form":"Form_form___cfIE","frame":"Form_frame__1JjpO","submitButton":"Form_submitButton__39G-q"};